module.exports = __webpack_public_path__ + "img/heart_16_bj.f8d98937.png";